import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Cookie } from 'lucide-react';
import { Button } from './ui/button';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookiesAccepted = localStorage.getItem('jrf-cookies-accepted');
    if (!cookiesAccepted) {
      // Show banner after a short delay
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('jrf-cookies-accepted', 'true');
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('jrf-cookies-accepted', 'essential-only');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9998] p-4 bg-white border-t shadow-lg">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-start gap-3">
            <Cookie className="w-6 h-6 text-pink-500 flex-shrink-0 mt-1" />
            <div>
              <p className="text-gray-700 text-sm">
                Utilizamos cookies propias y de terceros para mejorar tu experiencia de compra y analizar el uso de la web. 
                Al continuar navegando, aceptas nuestra{' '}
                <Link to="/politica-cookies" className="text-pink-500 hover:underline">
                  Política de Cookies
                </Link>.
              </p>
            </div>
          </div>
          <div className="flex gap-2 flex-shrink-0">
            <Button
              onClick={rejectCookies}
              variant="outline"
              size="sm"
              className="text-gray-600"
            >
              Solo esenciales
            </Button>
            <Button
              onClick={acceptCookies}
              size="sm"
              className="bg-gradient-to-r from-pink-500 to-purple-500 text-white"
            >
              Aceptar todas
            </Button>
          </div>
          <button
            onClick={rejectCookies}
            className="absolute top-2 right-2 md:hidden p-1 text-gray-400 hover:text-gray-600"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
